<template>
  <div class="container-detail">
    <div class="detail-header-buttons">
      <v-btn @click="back" style="width: auto !important" class="button-accept">
        <v-icon>mdi-chevron-left</v-icon>
        Вернуться к списку ссылок
      </v-btn>

      <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
        Редактировать
      </v-btn>
    </div>

    <div class="detail-main">
      <div class="detail-main-first-container" v-if="item">
        <div class="first-container-box">
          <div class="container-box-title">Метка</div>
          <div class="container-box-text">
            {{ item.label }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Заголовок</div>
          <div class="container-box-text">
            {{ item.title }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Описание</div>
          <div class="container-box-text">
            {{ item.description }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Ссылка</div>
          <div class="container-box-text">
            {{ item.link }}
          </div>
        </div>
      </div>
      <div class="detail-main-second-container">
        <div class="second-container-box">
          <div class="container-box-title">Изображение ссылки</div>
          <div class="container-box-text">
            Нажмите на изображение, чтобы увидеть его в полном размере
          </div>
        </div>

        <div v-if="item && item.image">
          <img @click="openDialogImg(item.image)" class="detail-img" :src="item.image" />
          <DialogImage v-model="dialogImg" :src="previewImage" />
        </div>

        <div class="second-container-box" style="margin-top: 32px" v-if="item && !item.isVisible">
          <div class="container-box-title">Параметры публикации и отображения</div>
          <div class="container-box-text">
            Скрыть из списка ссылок (ссылка не будет отображаться)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: () => ({
    item: null,
    dialogImg: false,
    previewImage: null,
  }),
  methods: {
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.push({ name: "Appeal", params: { selectedTicker: 3 } });
    },
    goToEdit() {
      this.$router.push({
        name: "LinkEdit",
        params: { id: this.$route.params.id },
      });
    },
    getItem() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/banner/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
        })
        .catch((err) => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        });
    },
  },
  created() {
    this.getItem();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;
  padding: 40px !important;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  .detail-main {
    display: flex;
    justify-content: space-between;

    .detail-main-first-container {
      width: 48%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }

    .detail-main-second-container {
      width: 48%;

      .detail-img {
        cursor: pointer;
        max-width: 300px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
